import axios from 'axios';
import consts from '@/static/js/consts';

export default {
  getAuctions({ state, commit }) {
    return new Promise((resolve, reject) => {
      axios.get((`${consts.ENDPOINTS.AUCTIONS_LIST}?page=${state.page || 1}`))
        .then((response) => {
          resolve(response.data);
          commit('setAuctions', response.data.data);
          commit('setPagination', response.data.pagination);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getAuctionDetails({ state, commit }) {
    return new Promise((resolve, reject) => {
      axios.get(consts.ENDPOINTS.AUCTION_DETAILS
        .replace('$1', state.auction.slug))
        .then((response) => {
          commit('setAuction', response.data.data);
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getAuctionsLots({ state, commit }) {
    return new Promise((resolve, reject) => {
      axios.get((`${consts.ENDPOINTS.AUCTION_LOTS}?page=${state.page || 1}`)
        .replace('$1', state.auction.id))
        .then((response) => {
          resolve(response.data);
          commit('setAuctionLots', response.data.data);
          commit('setPagination', response.data.pagination);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getAuctionsLotsDetails({ state, commit }) {
    return new Promise((resolve, reject) => {
      const id = state.auction.id || state.auction.slug;
      axios.get((`${consts.ENDPOINTS.AUCTION_LOTS}?page=${state.page || 1}&perPage=1`)
        .replace('$1', id))
        .then((response) => {
          resolve(response.data);
          commit('setLot', response.data.data[0]);
          commit('setPagination', response.data.pagination);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getAuctionsBids({ state, commit }) {
    return new Promise((resolve, reject) => {
      const id = state.auction.id || state.auction.slug;
      const lote = state.lot.id;
      axios.get((`${consts.ENDPOINTS.AUCTION_BIDS}`)
        .replace('$1', id)
        .replace('$2', lote))
        .then((response) => {
          commit('setBids', response.data.data);
          resolve(response.data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  setAuction({ commit }, payload) {
    commit('setAuction', payload);
  },
  setBids({ commit }, payload) {
    commit('setBids', payload);
  },
  addBids({ commit }, payload) {
    commit('addBids', payload);
  },
};
